import React from 'react';

import { MarkedListContainer } from './styles';

export const MarkedList = (props) => {
    return <MarkedListContainer>{props.children}</MarkedListContainer>;
};
